module.exports = __webpack_public_path__ + "img/jacobus_03.3415599b.png";